// extracted by mini-css-extract-plugin
export default {"wrapper":"Ay-z","viewport":"By-z","container":"Cy-z","slide":"Dy-z"};